import * as DOMPurify from 'dompurify';

const getSanitizedHtml = (content: string): string => (
  DOMPurify.sanitize(content, { ALLOWED_ATTR: ['href', 'target'], ALLOWED_TAGS: ['strong', 'em', 'a', 'br'] })
);

export {
  getSanitizedHtml,
};
